/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/restrictions/modal-special-settings/modal-special-settings.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '../../../../../../public/upgrade/core/date.service';
import * as import7 from '../../../../../../public/upgrade/root/ga/ga.service';
import * as import8 from '@angular/core/src/linker/view_type';
import * as import9 from '@angular/core/src/change_detection/constants';
import * as import10 from '@angular/core/src/linker/component_factory';
import * as import11 from '@angular/router/src/router_state';
import * as import12 from '../../../../../../public/upgrade/root/form-modal/form-modal.service';
import * as import13 from '../../../../../../public/upgrade/root/toast/notification.service';
import * as import14 from '../../../../../../public/upgrade/feature/restrictions/restrictions.service';
import * as import15 from '@angular/forms/src/form_builder';
import * as import16 from '@ngx-translate/core/src/translate.service';
import * as import17 from '../../../../../../public/upgrade/shared/sara-select/sara-select.component';
import * as import18 from '../../../shared/sara-select/sara-select.component.ngfactory';
import * as import19 from '@angular/core/src/linker/view_container';
import * as import20 from '../../../../../../public/upgrade/shared/sara-radio/sara-radio.component';
import * as import21 from '../../../shared/sara-radio/sara-radio.component.ngfactory';
import * as import22 from '../../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import23 from '../../../../../../public/upgrade/core/datepicker/datepicker-range.component';
import * as import24 from '../../../core/datepicker/datepicker-range.component.ngfactory';
import * as import25 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import26 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import27 from '@angular/core/src/linker/element_ref';
import * as import28 from '../../../../../../public/upgrade/core/datepicker/calendar-config';
import * as import29 from '@angular/common/src/directives/ng_class';
import * as import30 from '@angular/core/src/linker/query_list';
import * as import31 from '../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import32 from '../../../../../../public/upgrade/shared/eva-button/eva-button.component';
import * as import33 from '../../../shared/eva-button/eva-button.component.ngfactory';
import * as import34 from '@ngx-translate/core/src/translate.pipe';
import * as import35 from '@angular/core/src/linker/template_ref';
import * as import36 from '@angular/common/src/directives/ng_if';
export class Wrapper_ModalSpecialSettingsComponent {
  /*private*/ _eventHandler:Function;
  context:import0.ModalSpecialSettingsComponent;
  /*private*/ _changed:boolean;
  /*private*/ _changes:{[key: string]:any};
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  subscription0:any;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any) {
    this._changed = false;
    this._changes = {};
    this.context = new import0.ModalSpecialSettingsComponent(p0,p1,p2,p3,p4,p5,p6,p7);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
  }
  check_pointsOfSale(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.pointsOfSale = currValue;
      this._changes['pointsOfSale'] = new import1.SimpleChange(this._expr_0,currValue);
      this._expr_0 = currValue;
    }
  }
  check_selectedSpecialValue(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.selectedSpecialValue = currValue;
      this._changes['selectedSpecialValue'] = new import1.SimpleChange(this._expr_1,currValue);
      this._expr_1 = currValue;
    }
  }
  check_restrictions(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.restrictions = currValue;
      this._changes['restrictions'] = new import1.SimpleChange(this._expr_2,currValue);
      this._expr_2 = currValue;
    }
  }
  check_openModal(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this._changed = true;
      this.context.openModal = currValue;
      this._changes['openModal'] = new import1.SimpleChange(this._expr_3,currValue);
      this._expr_3 = currValue;
    }
  }
  check_posListForSelect(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this._changed = true;
      this.context.posListForSelect = currValue;
      this._changes['posListForSelect'] = new import1.SimpleChange(this._expr_4,currValue);
      this._expr_4 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) {
      if (changed) {
        this.context.ngOnChanges(this._changes);
        this._changes = {};
      }
      if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); }
    }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.savePosRestriction.subscribe(_eventHandler.bind(view,'savePosRestriction'))); }
  }
}
var renderType_ModalSpecialSettingsComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_ModalSpecialSettingsComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.ModalSpecialSettingsComponent>;
  _DateService_0_3:import6.DateService;
  _GAService_0_4:import7.GAService;
  _ModalSpecialSettingsComponent_0_5:Wrapper_ModalSpecialSettingsComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_ModalSpecialSettingsComponent_Host0,renderType_ModalSpecialSettingsComponent_Host,import8.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'modal-special-settings',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_ModalSpecialSettingsComponent0(this.viewUtils,this,0,this._el_0);
    this._DateService_0_3 = new import6.DateService();
    this._GAService_0_4 = new import7.GAService();
    this._ModalSpecialSettingsComponent_0_5 = new Wrapper_ModalSpecialSettingsComponent(this.injectorGet(import11.ActivatedRoute,this.parentIndex),this.injectorGet(import12.FormModalService,this.parentIndex),this.injectorGet(import13.NotificationService,this.parentIndex),this.injectorGet(import14.RestrictionsService,this.parentIndex),this.injectorGet(import15.FormBuilder,this.parentIndex),this.injectorGet(import16.TranslateService,this.parentIndex),this._DateService_0_3,this._GAService_0_4);
    this.compView_0.create(this._ModalSpecialSettingsComponent_0_5.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import10.ComponentRef_<any>(0,this,this._el_0,this._ModalSpecialSettingsComponent_0_5.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import6.DateService) && (0 === requestNodeIndex))) { return this._DateService_0_3; }
    if (((token === import7.GAService) && (0 === requestNodeIndex))) { return this._GAService_0_4; }
    if (((token === import0.ModalSpecialSettingsComponent) && (0 === requestNodeIndex))) { return this._ModalSpecialSettingsComponent_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ModalSpecialSettingsComponent_0_5.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._ModalSpecialSettingsComponent_0_5.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const ModalSpecialSettingsComponentNgFactory:import10.ComponentFactory<import0.ModalSpecialSettingsComponent> = new import10.ComponentFactory<import0.ModalSpecialSettingsComponent>('modal-special-settings',View_ModalSpecialSettingsComponent_Host0,import0.ModalSpecialSettingsComponent);
const styles_ModalSpecialSettingsComponent:any[] = ([] as any[]);
class View_ModalSpecialSettingsComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import2.AppView<import17.SaraSelectComponent>;
  _SaraSelectComponent_2_3:import18.Wrapper_SaraSelectComponent;
  _text_3:any;
  _text_4:any;
  _map_7:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_ModalSpecialSettingsComponent1,renderType_ModalSpecialSettingsComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_7 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        name: p0,
        itemList: p1
      }
      ;
    });
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','content eva-3-validation -top-left'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'sara-select',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import18.View_SaraSelectComponent0(this.viewUtils,this,2,this._el_2);
    this._SaraSelectComponent_2_3 = new import18.Wrapper_SaraSelectComponent();
    this._text_3 = this.renderer.createText((null as any),'\n                ',(null as any));
    this.compView_2.create(this._SaraSelectComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_2));
    this._SaraSelectComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.SaraSelectComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._SaraSelectComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.errors['posName'];
    this._SaraSelectComponent_2_3.check_error(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = 'pointsOfSale';
    this._SaraSelectComponent_2_3.check_name(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = this.parentView.context.defaultSelectOption;
    this._SaraSelectComponent_2_3.check_default(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = this._map_7('',this.parentView.context.posListForSelect);
    this._SaraSelectComponent_2_3.check_messages(currVal_2_0_3,throwOnChange,false);
    const currVal_2_0_4:any = false;
    this._SaraSelectComponent_2_3.check_required(currVal_2_0_4,throwOnChange,false);
    const currVal_2_0_5:any = (this.parentView.context.selectedSpecialValue.status != 'new');
    this._SaraSelectComponent_2_3.check_disabled(currVal_2_0_5,throwOnChange,false);
    const currVal_2_0_6:any = this.parentView.context.selectedSpecialValue.pointOfSaleOid;
    this._SaraSelectComponent_2_3.check_model(currVal_2_0_6,throwOnChange,false);
    this._SaraSelectComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._SaraSelectComponent_2_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.selectedSpecialValue.pointOfSaleOid = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.parentView.context.onchangePos()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_ModalSpecialSettingsComponent2 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import2.AppView<import17.SaraSelectComponent>;
  _SaraSelectComponent_2_3:import18.Wrapper_SaraSelectComponent;
  _text_3:any;
  _text_4:any;
  _map_7:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_ModalSpecialSettingsComponent2,renderType_ModalSpecialSettingsComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_7 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        name: p0,
        itemList: p1
      }
      ;
    });
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-3 -md-3 -sm-12'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'sara-select',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import18.View_SaraSelectComponent0(this.viewUtils,this,2,this._el_2);
    this._SaraSelectComponent_2_3 = new import18.Wrapper_SaraSelectComponent();
    this._text_3 = this.renderer.createText((null as any),'\n            ',(null as any));
    this.compView_2.create(this._SaraSelectComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n\n        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this._SaraSelectComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.SaraSelectComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._SaraSelectComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.errors['daysInAdvance'];
    this._SaraSelectComponent_2_3.check_error(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = 'daysInAdvance';
    this._SaraSelectComponent_2_3.check_name(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = this._map_7('restrictions.SPECIAL_CONFIG.MODAL.selectDescription1',this.parentView.context.selectReleaseList);
    this._SaraSelectComponent_2_3.check_messages(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = false;
    this._SaraSelectComponent_2_3.check_required(currVal_2_0_3,throwOnChange,false);
    const currVal_2_0_4:any = this.parentView.context.selectedSpecialValue.daysInAdvance;
    this._SaraSelectComponent_2_3.check_model(currVal_2_0_4,throwOnChange,false);
    this._SaraSelectComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._SaraSelectComponent_2_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.selectedSpecialValue.daysInAdvance = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_ModalSpecialSettingsComponent3 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import2.AppView<import17.SaraSelectComponent>;
  _SaraSelectComponent_2_3:import18.Wrapper_SaraSelectComponent;
  _text_3:any;
  _text_4:any;
  _map_7:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_ModalSpecialSettingsComponent3,renderType_ModalSpecialSettingsComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_7 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        name: p0,
        itemList: p1
      }
      ;
    });
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-3 -md-3 -sm-12'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'sara-select',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import18.View_SaraSelectComponent0(this.viewUtils,this,2,this._el_2);
    this._SaraSelectComponent_2_3 = new import18.Wrapper_SaraSelectComponent();
    this._text_3 = this.renderer.createText((null as any),'\n            ',(null as any));
    this.compView_2.create(this._SaraSelectComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_2));
    this._SaraSelectComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.SaraSelectComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._SaraSelectComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.errors['minRentalLength'];
    this._SaraSelectComponent_2_3.check_error(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = 'minRentalLength';
    this._SaraSelectComponent_2_3.check_name(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = this._map_7('restrictions.SPECIAL_CONFIG.MODAL.selectDescription2',this.parentView.context.selectMinDurationList);
    this._SaraSelectComponent_2_3.check_messages(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = false;
    this._SaraSelectComponent_2_3.check_required(currVal_2_0_3,throwOnChange,false);
    const currVal_2_0_4:any = this.parentView.context.selectedSpecialValue.minRentalLength;
    this._SaraSelectComponent_2_3.check_model(currVal_2_0_4,throwOnChange,false);
    this._SaraSelectComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._SaraSelectComponent_2_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.selectedSpecialValue.minRentalLength = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.parentView.context.onMinRentalLengthChange()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_ModalSpecialSettingsComponent4 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import2.AppView<import17.SaraSelectComponent>;
  _SaraSelectComponent_2_3:import18.Wrapper_SaraSelectComponent;
  _text_3:any;
  _text_4:any;
  _map_7:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_ModalSpecialSettingsComponent4,renderType_ModalSpecialSettingsComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_7 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        name: p0,
        itemList: p1
      }
      ;
    });
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-3 -md-3 -sm-12'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'sara-select',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import18.View_SaraSelectComponent0(this.viewUtils,this,2,this._el_2);
    this._SaraSelectComponent_2_3 = new import18.Wrapper_SaraSelectComponent();
    this._text_3 = this.renderer.createText((null as any),'\n            ',(null as any));
    this.compView_2.create(this._SaraSelectComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this._SaraSelectComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.SaraSelectComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._SaraSelectComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.errors['minRentalLength'];
    this._SaraSelectComponent_2_3.check_error(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = 'maxRentalLength';
    this._SaraSelectComponent_2_3.check_name(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = this._map_7('restrictions.SPECIAL_CONFIG.MODAL.selectDescription2',this.parentView.context.selectMaxDurationList);
    this._SaraSelectComponent_2_3.check_messages(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = false;
    this._SaraSelectComponent_2_3.check_required(currVal_2_0_3,throwOnChange,false);
    const currVal_2_0_4:any = this.parentView.context.selectedSpecialValue.maxRentalLength;
    this._SaraSelectComponent_2_3.check_model(currVal_2_0_4,throwOnChange,false);
    this._SaraSelectComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  dirtyParentQueriesInternal():void {
    (<View_ModalSpecialSettingsComponent0>this.parentView)._viewQuery_maxRentalLength_0.setDirty();
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._SaraSelectComponent_2_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.selectedSpecialValue.maxRentalLength = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_ModalSpecialSettingsComponent5 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  compView_4:import2.AppView<import20.SaraRadioComponent>;
  _SaraRadioComponent_4_3:import21.Wrapper_SaraRadioComponent;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _el_9:any;
  compView_9:import2.AppView<import20.SaraRadioComponent>;
  _SaraRadioComponent_9_3:import21.Wrapper_SaraRadioComponent;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _map_17:any;
  _map_18:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_ModalSpecialSettingsComponent5,renderType_ModalSpecialSettingsComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_17 = import3.pureProxy3((p0:any,p1:any,p2:any):{[key: string]:any} => {
      return {
        value: p0,
        id: p1,
        disable: p2
      }
      ;
    });
    this._map_18 = import3.pureProxy3((p0:any,p1:any,p2:any):{[key: string]:any} => {
      return {
        value: p0,
        id: p1,
        disable: p2
      }
      ;
    });
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','input-container'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','-lg-12 -md-12 -sm-12 -eva-3-mt-sm'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'sara-radio',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_4 = new import21.View_SaraRadioComponent0(this.viewUtils,this,4,this._el_4);
    this._SaraRadioComponent_4_3 = new import21.Wrapper_SaraRadioComponent();
    this.compView_4.create(this._SaraRadioComponent_4_3.context);
    this._text_5 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_7 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','-lg-12 -md-12 -sm-12 -eva-3-mt-sm'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'\n                ',(null as any));
    this._el_9 = import3.createRenderElement(this.renderer,this._el_7,'sara-radio',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_9 = new import21.View_SaraRadioComponent0(this.viewUtils,this,9,this._el_9);
    this._SaraRadioComponent_9_3 = new import21.Wrapper_SaraRadioComponent();
    this._text_10 = this.renderer.createText((null as any),'\n                ',(null as any));
    this.compView_9.create(this._SaraRadioComponent_9_3.context);
    this._text_11 = this.renderer.createText(this._el_7,'\n            ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_4));
    this._SaraRadioComponent_4_3.subscribe(this,this.eventHandler(this.handleEvent_4),true,true);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_9,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_9));
    this._SaraRadioComponent_9_3.subscribe(this,this.eventHandler(this.handleEvent_9),false,true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._text_12
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import20.SaraRadioComponent) && (4 === requestNodeIndex))) { return this._SaraRadioComponent_4_3.context; }
    if (((token === import20.SaraRadioComponent) && ((9 <= requestNodeIndex) && (requestNodeIndex <= 10)))) { return this._SaraRadioComponent_9_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_4_0_0:any = 'dateCategory';
    this._SaraRadioComponent_4_3.check_name(currVal_4_0_0,throwOnChange,false);
    const currVal_4_0_1:any = this._map_17('restrictions.SPECIAL_CONFIG.MODAL.subtitle4.checkbox1','date_always',(this.parentView.context.selectedSpecialValue.pointOfSaleOid == (0 - 1)));
    this._SaraRadioComponent_4_3.check_item(currVal_4_0_1,throwOnChange,false);
    const currVal_4_0_2:any = this.parentView.context.selectedSpecialValue.dateConfigRange;
    this._SaraRadioComponent_4_3.check_model(currVal_4_0_2,throwOnChange,false);
    this._SaraRadioComponent_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_9_0_0:any = 'dateCategory';
    this._SaraRadioComponent_9_3.check_name(currVal_9_0_0,throwOnChange,false);
    const currVal_9_0_1:any = this._map_18('restrictions.SPECIAL_CONFIG.MODAL.subtitle4.checkbox2','date_range',false);
    this._SaraRadioComponent_9_3.check_item(currVal_9_0_1,throwOnChange,false);
    const currVal_9_0_2:any = this.parentView.context.selectedSpecialValue.dateConfigRange;
    this._SaraRadioComponent_9_3.check_model(currVal_9_0_2,throwOnChange,false);
    this._SaraRadioComponent_9_3.ngDoCheck(this,this._el_9,throwOnChange);
    this.compView_4.internalDetectChanges(throwOnChange);
    this.compView_9.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_4.destroy();
    this.compView_9.destroy();
    this._SaraRadioComponent_4_3.ngOnDestroy();
    this._SaraRadioComponent_9_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.selectedSpecialValue.dateConfigRange = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.parentView.context.onChangeConfigRange()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_9(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.selectedSpecialValue.dateConfigRange = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_ModalSpecialSettingsComponent6 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgClass_2_3:import22.Wrapper_NgClass;
  _text_3:any;
  _el_4:any;
  compView_4:import2.AppView<import23.DatePickerRangeComponent>;
  _DatePickerRangeComponent_4_3:import24.Wrapper_DatePickerRangeComponent;
  _text_5:any;
  _text_6:any;
  _map_10:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import19.ViewContainer) {
    super(View_ModalSpecialSettingsComponent6,renderType_ModalSpecialSettingsComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_10 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'disable-calendar-range': p0};
    });
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-xlg'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._NgClass_2_3 = new import22.Wrapper_NgClass(this.parentView.injectorGet(import25.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import26.KeyValueDiffers,this.parentIndex),new import27.ElementRef(this._el_2),this.renderer);
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'sara-datepicker-range',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_4 = new import24.View_DatePickerRangeComponent0(this.viewUtils,this,4,this._el_4);
    this._DatePickerRangeComponent_4_3 = new import24.Wrapper_DatePickerRangeComponent(new import27.ElementRef(this._el_4),this.parentView.injectorGet(import28.CalendarConfig,this.parentIndex));
    this.compView_4.create(this._DatePickerRangeComponent_4_3.context);
    this._text_5 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray4(4,'periodChange',(null as any),'periodUpdated',(null as any)),this.eventHandler(this.handleEvent_4));
    this._DatePickerRangeComponent_4_3.subscribe(this,this.eventHandler(this.handleEvent_4),true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import23.DatePickerRangeComponent) && (4 === requestNodeIndex))) { return this._DatePickerRangeComponent_4_3.context; }
    if (((token === import29.NgClass) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 5)))) { return this._NgClass_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this._map_10((this.parentView.context.selectedSpecialValue.dateConfigRange == 'date_always'));
    this._NgClass_2_3.check_ngClass(currVal_2_0_0,throwOnChange,false);
    this._NgClass_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_4_0_0:any = this.parentView.context.calendarConfig.position;
    this._DatePickerRangeComponent_4_3.check_position(currVal_4_0_0,throwOnChange,false);
    const currVal_4_0_1:any = this.parentView.context.calendarConfig.format;
    this._DatePickerRangeComponent_4_3.check_format(currVal_4_0_1,throwOnChange,false);
    const currVal_4_0_2:any = this.parentView.context.calendarConfig.disable;
    this._DatePickerRangeComponent_4_3.check_disableDates(currVal_4_0_2,throwOnChange,false);
    const currVal_4_0_3:any = this.parentView.context.selectedSpecialValue.period;
    this._DatePickerRangeComponent_4_3.check_period(currVal_4_0_3,throwOnChange,false);
    const currVal_4_0_4:any = this.parentView.context.getValidityPeriodErrors();
    this._DatePickerRangeComponent_4_3.check_errors(currVal_4_0_4,throwOnChange,false);
    this._DatePickerRangeComponent_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    this.compView_4.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_4.destroy();
    this._DatePickerRangeComponent_4_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'periodChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.selectedSpecialValue.period = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'periodUpdated')) {
      const pd_sub_1:any = ((<any>this.parentView.context.onPeriodUpdated($event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
var renderType_ModalSpecialSettingsComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_ModalSpecialSettingsComponent,{});
export class View_ModalSpecialSettingsComponent0 extends import2.AppView<import0.ModalSpecialSettingsComponent> {
  _viewQuery_maxRentalLength_0:import30.QueryList<any>;
  _viewQuery_modalSpecialForm_1:import30.QueryList<any>;
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _anchor_9:any;
  /*private*/ _vc_9:import19.ViewContainer;
  _TemplateRef_9_5:any;
  _NgIf_9_6:import31.Wrapper_NgIf;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _text_23:any;
  _anchor_24:any;
  /*private*/ _vc_24:import19.ViewContainer;
  _TemplateRef_24_5:any;
  _NgIf_24_6:import31.Wrapper_NgIf;
  _text_25:any;
  _text_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _text_30:any;
  _el_31:any;
  _text_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _anchor_38:any;
  /*private*/ _vc_38:import19.ViewContainer;
  _TemplateRef_38_5:any;
  _NgIf_38_6:import31.Wrapper_NgIf;
  _text_39:any;
  _anchor_40:any;
  /*private*/ _vc_40:import19.ViewContainer;
  _TemplateRef_40_5:any;
  _NgIf_40_6:import31.Wrapper_NgIf;
  _text_41:any;
  _text_42:any;
  _text_43:any;
  _el_44:any;
  _text_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _text_49:any;
  _el_50:any;
  _text_51:any;
  _el_52:any;
  _text_53:any;
  _anchor_54:any;
  /*private*/ _vc_54:import19.ViewContainer;
  _TemplateRef_54_5:any;
  _NgIf_54_6:import31.Wrapper_NgIf;
  _text_55:any;
  _text_56:any;
  _text_57:any;
  _anchor_58:any;
  /*private*/ _vc_58:import19.ViewContainer;
  _TemplateRef_58_5:any;
  _NgIf_58_6:import31.Wrapper_NgIf;
  _text_59:any;
  _el_60:any;
  _text_61:any;
  _el_62:any;
  _text_63:any;
  _el_64:any;
  compView_64:import2.AppView<import32.EvaButtonComponent>;
  _EvaButtonComponent_64_3:import33.Wrapper_EvaButtonComponent;
  _text_65:any;
  _text_66:any;
  _text_67:any;
  /*private*/ _expr_90:any;
  _pipe_translate_0:import34.TranslatePipe;
  /*private*/ _expr_92:any;
  _pipe_translate_1:import34.TranslatePipe;
  /*private*/ _expr_94:any;
  _pipe_translate_2:import34.TranslatePipe;
  /*private*/ _expr_96:any;
  _pipe_translate_3:import34.TranslatePipe;
  /*private*/ _expr_98:any;
  _pipe_translate_4:import34.TranslatePipe;
  /*private*/ _expr_100:any;
  _pipe_translate_5:import34.TranslatePipe;
  /*private*/ _expr_102:any;
  _pipe_translate_6:import34.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_ModalSpecialSettingsComponent0,renderType_ModalSpecialSettingsComponent,import8.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
    this._expr_90 = import1.UNINITIALIZED;
    this._expr_92 = import1.UNINITIALIZED;
    this._expr_94 = import1.UNINITIALIZED;
    this._expr_96 = import1.UNINITIALIZED;
    this._expr_98 = import1.UNINITIALIZED;
    this._expr_100 = import1.UNINITIALIZED;
    this._expr_102 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._viewQuery_maxRentalLength_0 = new import30.QueryList<any>();
    this._viewQuery_modalSpecialForm_1 = new import30.QueryList<any>();
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','modal-border-bottom'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pb-sm'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'h5',new import3.InlineArray2(2,'class','modal-title eva-3-h5'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._anchor_9 = this.renderer.createTemplateAnchor(this._el_4,(null as any));
    this._vc_9 = new import19.ViewContainer(9,4,this,this._anchor_9);
    this._TemplateRef_9_5 = new import35.TemplateRef_(this,9,this._anchor_9);
    this._NgIf_9_6 = new import31.Wrapper_NgIf(this._vc_9.vcRef,this._TemplateRef_9_5);
    this._text_10 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_13 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,parentRenderNode,'h5',new import3.InlineArray2(2,'class','modal-title eva-3-h5 -eva-3-mt-xlg'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'',(null as any));
    this._text_16 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,parentRenderNode,'h5',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','modal-border-bottom -eva-3-mt-md'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n    ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_20,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pb-sm'),(null as any));
    this._text_23 = this.renderer.createText(this._el_22,'\n        ',(null as any));
    this._anchor_24 = this.renderer.createTemplateAnchor(this._el_22,(null as any));
    this._vc_24 = new import19.ViewContainer(24,22,this,this._anchor_24);
    this._TemplateRef_24_5 = new import35.TemplateRef_(this,24,this._anchor_24);
    this._NgIf_24_6 = new import31.Wrapper_NgIf(this._vc_24.vcRef,this._TemplateRef_24_5);
    this._text_25 = this.renderer.createText(this._el_22,'\n    ',(null as any));
    this._text_26 = this.renderer.createText(this._el_20,'\n',(null as any));
    this._text_27 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,parentRenderNode,'h5',new import3.InlineArray2(2,'class','modal-title eva-3-h5 -eva-3-mt-xlg'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'',(null as any));
    this._text_30 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_31 = import3.createRenderElement(this.renderer,parentRenderNode,'h5',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_32 = this.renderer.createText(this._el_31,'',(null as any));
    this._text_33 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','modal-border-bottom -eva-3-mt-md'),(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'\n    ',(null as any));
    this._el_36 = import3.createRenderElement(this.renderer,this._el_34,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pb-sm'),(null as any));
    this._text_37 = this.renderer.createText(this._el_36,'\n        ',(null as any));
    this._anchor_38 = this.renderer.createTemplateAnchor(this._el_36,(null as any));
    this._vc_38 = new import19.ViewContainer(38,36,this,this._anchor_38);
    this._TemplateRef_38_5 = new import35.TemplateRef_(this,38,this._anchor_38);
    this._NgIf_38_6 = new import31.Wrapper_NgIf(this._vc_38.vcRef,this._TemplateRef_38_5);
    this._text_39 = this.renderer.createText(this._el_36,'\n\n        ',(null as any));
    this._anchor_40 = this.renderer.createTemplateAnchor(this._el_36,(null as any));
    this._vc_40 = new import19.ViewContainer(40,36,this,this._anchor_40);
    this._TemplateRef_40_5 = new import35.TemplateRef_(this,40,this._anchor_40);
    this._NgIf_40_6 = new import31.Wrapper_NgIf(this._vc_40.vcRef,this._TemplateRef_40_5);
    this._text_41 = this.renderer.createText(this._el_36,'\n    ',(null as any));
    this._text_42 = this.renderer.createText(this._el_34,'\n',(null as any));
    this._text_43 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_44 = import3.createRenderElement(this.renderer,parentRenderNode,'h5',new import3.InlineArray2(2,'class','modal-title eva-3-h5 -eva-3-mt-xlg'),(null as any));
    this._text_45 = this.renderer.createText(this._el_44,'',(null as any));
    this._text_46 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_47 = import3.createRenderElement(this.renderer,parentRenderNode,'h5',new import3.InlineArray2(2,'class','eva-3-p -eva-3-mb-xsm'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'',(null as any));
    this._text_49 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_50 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray8(6,'class','-md-12 -sm-12','qadata','dateSettings','style','padding-left: 0'),(null as any));
    this._text_51 = this.renderer.createText(this._el_50,'\n    ',(null as any));
    this._el_52 = import3.createRenderElement(this.renderer,this._el_50,'div',new import3.InlineArray2(2,'class','eva-3-input -md -validate -validate-sm -top-right'),(null as any));
    this._text_53 = this.renderer.createText(this._el_52,'\n        ',(null as any));
    this._anchor_54 = this.renderer.createTemplateAnchor(this._el_52,(null as any));
    this._vc_54 = new import19.ViewContainer(54,52,this,this._anchor_54);
    this._TemplateRef_54_5 = new import35.TemplateRef_(this,54,this._anchor_54);
    this._NgIf_54_6 = new import31.Wrapper_NgIf(this._vc_54.vcRef,this._TemplateRef_54_5);
    this._text_55 = this.renderer.createText(this._el_52,'\n    ',(null as any));
    this._text_56 = this.renderer.createText(this._el_50,'\n',(null as any));
    this._text_57 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._anchor_58 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._vc_58 = new import19.ViewContainer(58,(null as any),this,this._anchor_58);
    this._TemplateRef_58_5 = new import35.TemplateRef_(this,58,this._anchor_58);
    this._NgIf_58_6 = new import31.Wrapper_NgIf(this._vc_58.vcRef,this._TemplateRef_58_5);
    this._text_59 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_60 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-mt-xlg'),(null as any));
    this._text_61 = this.renderer.createText(this._el_60,'\n    ',(null as any));
    this._el_62 = import3.createRenderElement(this.renderer,this._el_60,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_63 = this.renderer.createText(this._el_62,'\n        ',(null as any));
    this._el_64 = import3.createRenderElement(this.renderer,this._el_62,'eva-button',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_64 = new import33.View_EvaButtonComponent0(this.viewUtils,this,64,this._el_64);
    this._EvaButtonComponent_64_3 = new import33.Wrapper_EvaButtonComponent();
    this.compView_64.create(this._EvaButtonComponent_64_3.context);
    this._text_65 = this.renderer.createText(this._el_62,'\n    ',(null as any));
    this._text_66 = this.renderer.createText(this._el_60,'\n',(null as any));
    this._text_67 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._pipe_translate_0 = new import34.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import34.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import34.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_3 = new import34.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_4 = new import34.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_5 = new import34.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_6 = new import34.TranslatePipe(this.parentView.injectorGet(import16.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_64,new import3.InlineArray2(2,'action',(null as any)),this.eventHandler(this.handleEvent_64));
    this._EvaButtonComponent_64_3.subscribe(this,this.eventHandler(this.handleEvent_64),true);
    this._viewQuery_modalSpecialForm_1.reset(([] as any[]));
    this.context.form = this._viewQuery_modalSpecialForm_1.first;
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._anchor_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._anchor_24,
      this._text_25,
      this._text_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._anchor_38,
      this._text_39,
      this._anchor_40,
      this._text_41,
      this._text_42,
      this._text_43,
      this._el_44,
      this._text_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._text_49,
      this._el_50,
      this._text_51,
      this._el_52,
      this._text_53,
      this._anchor_54,
      this._text_55,
      this._text_56,
      this._text_57,
      this._anchor_58,
      this._text_59,
      this._el_60,
      this._text_61,
      this._el_62,
      this._text_63,
      this._el_64,
      this._text_65,
      this._text_66,
      this._text_67
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import35.TemplateRef) && (9 === requestNodeIndex))) { return this._TemplateRef_9_5; }
    if (((token === import36.NgIf) && (9 === requestNodeIndex))) { return this._NgIf_9_6.context; }
    if (((token === import35.TemplateRef) && (24 === requestNodeIndex))) { return this._TemplateRef_24_5; }
    if (((token === import36.NgIf) && (24 === requestNodeIndex))) { return this._NgIf_24_6.context; }
    if (((token === import35.TemplateRef) && (38 === requestNodeIndex))) { return this._TemplateRef_38_5; }
    if (((token === import36.NgIf) && (38 === requestNodeIndex))) { return this._NgIf_38_6.context; }
    if (((token === import35.TemplateRef) && (40 === requestNodeIndex))) { return this._TemplateRef_40_5; }
    if (((token === import36.NgIf) && (40 === requestNodeIndex))) { return this._NgIf_40_6.context; }
    if (((token === import35.TemplateRef) && (54 === requestNodeIndex))) { return this._TemplateRef_54_5; }
    if (((token === import36.NgIf) && (54 === requestNodeIndex))) { return this._NgIf_54_6.context; }
    if (((token === import35.TemplateRef) && (58 === requestNodeIndex))) { return this._TemplateRef_58_5; }
    if (((token === import36.NgIf) && (58 === requestNodeIndex))) { return this._NgIf_58_6.context; }
    if (((token === import32.EvaButtonComponent) && (64 === requestNodeIndex))) { return this._EvaButtonComponent_64_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_9_0_0:boolean = !!this.context.selectedSpecialValue;
    this._NgIf_9_6.check_ngIf(currVal_9_0_0,throwOnChange,false);
    this._NgIf_9_6.ngDoCheck(this,this._anchor_9,throwOnChange);
    const currVal_24_0_0:boolean = !!this.context.selectedSpecialValue;
    this._NgIf_24_6.check_ngIf(currVal_24_0_0,throwOnChange,false);
    this._NgIf_24_6.ngDoCheck(this,this._anchor_24,throwOnChange);
    const currVal_38_0_0:boolean = !!this.context.selectedSpecialValue;
    this._NgIf_38_6.check_ngIf(currVal_38_0_0,throwOnChange,false);
    this._NgIf_38_6.ngDoCheck(this,this._anchor_38,throwOnChange);
    const currVal_40_0_0:boolean = !!this.context.selectedSpecialValue;
    this._NgIf_40_6.check_ngIf(currVal_40_0_0,throwOnChange,false);
    this._NgIf_40_6.ngDoCheck(this,this._anchor_40,throwOnChange);
    const currVal_54_0_0:boolean = !!this.context.selectedSpecialValue;
    this._NgIf_54_6.check_ngIf(currVal_54_0_0,throwOnChange,false);
    this._NgIf_54_6.ngDoCheck(this,this._anchor_54,throwOnChange);
    const currVal_58_0_0:boolean = !!this.context.selectedSpecialValue;
    this._NgIf_58_6.check_ngIf(currVal_58_0_0,throwOnChange,false);
    this._NgIf_58_6.ngDoCheck(this,this._anchor_58,throwOnChange);
    const currVal_64_0_0:any = this.context.saveButton;
    this._EvaButtonComponent_64_3.check_button(currVal_64_0_0,throwOnChange,false);
    this._EvaButtonComponent_64_3.ngDoCheck(this,this._el_64,throwOnChange);
    this._vc_9.detectChangesInNestedViews(throwOnChange);
    this._vc_24.detectChangesInNestedViews(throwOnChange);
    this._vc_38.detectChangesInNestedViews(throwOnChange);
    this._vc_40.detectChangesInNestedViews(throwOnChange);
    this._vc_54.detectChangesInNestedViews(throwOnChange);
    this._vc_58.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_90:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_0.transform('restrictions.SPECIAL_CONFIG.MODAL.subtitle1')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_90,currVal_90))) {
      this.renderer.setText(this._text_7,currVal_90);
      this._expr_90 = currVal_90;
    }
    valUnwrapper.reset();
    const currVal_92:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_1.transform('restrictions.SPECIAL_CONFIG.MODAL.subtitle2')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_92,currVal_92))) {
      this.renderer.setText(this._text_15,currVal_92);
      this._expr_92 = currVal_92;
    }
    valUnwrapper.reset();
    const currVal_94:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_2.transform('restrictions.SPECIAL_CONFIG.MODAL.description2')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_94,currVal_94))) {
      this.renderer.setText(this._text_18,currVal_94);
      this._expr_94 = currVal_94;
    }
    valUnwrapper.reset();
    const currVal_96:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_3.transform('restrictions.SPECIAL_CONFIG.MODAL.subtitle3')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_96,currVal_96))) {
      this.renderer.setText(this._text_29,currVal_96);
      this._expr_96 = currVal_96;
    }
    valUnwrapper.reset();
    const currVal_98:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_4.transform('restrictions.SPECIAL_CONFIG.MODAL.description3')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_98,currVal_98))) {
      this.renderer.setText(this._text_32,currVal_98);
      this._expr_98 = currVal_98;
    }
    valUnwrapper.reset();
    const currVal_100:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_5.transform('restrictions.SPECIAL_CONFIG.MODAL.subtitle4')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_100,currVal_100))) {
      this.renderer.setText(this._text_45,currVal_100);
      this._expr_100 = currVal_100;
    }
    valUnwrapper.reset();
    const currVal_102:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_6.transform('restrictions.SPECIAL_CONFIG.MODAL.description4')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_102,currVal_102))) {
      this.renderer.setText(this._text_48,currVal_102);
      this._expr_102 = currVal_102;
    }
    this.compView_64.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if (this._viewQuery_maxRentalLength_0.dirty) {
        this._viewQuery_maxRentalLength_0.reset([this._vc_40.mapNestedViews(View_ModalSpecialSettingsComponent4,(nestedView:View_ModalSpecialSettingsComponent4):any => {
          return [nestedView._SaraSelectComponent_2_3.context];
      })]);
      this.context.maxRentalLengthSelect = this._viewQuery_maxRentalLength_0.first;
    } }
  }
  destroyInternal():void {
    this._vc_9.destroyNestedViews();
    this._vc_24.destroyNestedViews();
    this._vc_38.destroyNestedViews();
    this._vc_40.destroyNestedViews();
    this._vc_54.destroyNestedViews();
    this._vc_58.destroyNestedViews();
    this.compView_64.destroy();
    this._EvaButtonComponent_64_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 9)) { return new View_ModalSpecialSettingsComponent1(this.viewUtils,this,9,this._anchor_9,this._vc_9); }
    if ((nodeIndex == 24)) { return new View_ModalSpecialSettingsComponent2(this.viewUtils,this,24,this._anchor_24,this._vc_24); }
    if ((nodeIndex == 38)) { return new View_ModalSpecialSettingsComponent3(this.viewUtils,this,38,this._anchor_38,this._vc_38); }
    if ((nodeIndex == 40)) { return new View_ModalSpecialSettingsComponent4(this.viewUtils,this,40,this._anchor_40,this._vc_40); }
    if ((nodeIndex == 54)) { return new View_ModalSpecialSettingsComponent5(this.viewUtils,this,54,this._anchor_54,this._vc_54); }
    if ((nodeIndex == 58)) { return new View_ModalSpecialSettingsComponent6(this.viewUtils,this,58,this._anchor_58,this._vc_58); }
    return (null as any);
  }
  handleEvent_64(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'action')) {
      const pd_sub_0:any = ((<any>this.context.saveRestriction()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/restrictions/modal-special-settings/modal-special-settings.component.ngfactory.ts